// extracted by mini-css-extract-plugin
export var supportMessage = "IjbDHGUydr2qn5Q1RcCR";